const component = "move-section-appliances-wizard";

export const moveSectionAppliancesWizard = {
  component,
  selectSectionTargetStep: {
    wizardTab: `${component}/select-section-target-step`,
    message: `${component}/select-section-target-step/message`,
    selectedAppliancesList: `${component}/select-section-target-step/selected-appliances-list`,
  },
  migrationSummaryStep: {
    wizardTab: `${component}/migration-summary-step`,
    targetSectionName: `${component}/migration-summary-step/target-section-name`,
    selectedAppliancesList: `${component}/migration-summary-step/selected-appliances-list`,
  },
};
